import React, { useContext, useEffect,useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Form, Input, Button, Text, notification, Modal } from 'antd';
import { StoreContext } from "../../store";
import { setUserInfoApi, setAccountDetail, updateUserInfo } from "../../actions";
import { update_account_funcs } from "../../Api"

const BranchItemDetail = () => {
  const [dataToShow, setData] = useState([]);
  const { state:{ branchDetail: { branch } }, dispatch } = useContext(StoreContext);
  const history = useHistory();
  const [form] = Form.useForm();
 
  const BranchMag = () => {
    history.push("/branchmag");
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleUpdate = async (event) => {
    console.log("handleUpdate:" ,userData);
    setIsModalVisible(false);
    const result = await update_account_funcs(userData);
    BranchMag();
  };

  const [userData, updateFormUserData] = useState(branch);
  const handleChange = (event) => {
    //console.log(`userData.admin: ${userData.admin}`)
    updateFormUserData({
      ...userData,
      [event.target.name]: event.target.value.trim()
    });

    if(event.target.name === 'admin'){
      updateFormUserData({
        ...userData,
        [event.target.name]: event.target.checked
      });
    }
    //console.log("userData:" ,userData);
    //console.log(`${event.target.name}: ${event.target.checked}`)
  };

  console.log("BranchItemDetail Enter: ", branch);
  //console.log("BranchItemDetail Enter: ", userData);
  useEffect(() => {
    console.log("useEffect:" ,userData);
    const branchs = [];
    branchs.push(branch);
    setData(branchs);
    localStorage.setItem("branch", JSON.stringify(branch));
  }, [branch]);

  return (
    <div>
      {dataToShow.map(branch => {
        return (
          <div className="layout_limit" key={branch.id} >
            <div className="accform-wrapper">
            <img src="/images/menu_back_btn.png" className="back_s_btn" onClick={BranchMag}/>
              <p className="acc-title">{branch.name}</p> 
                <Button
                  htmlType="submit"className="account_remove__button acc_btn" onClick={showModal}
                >
                  Update
                </Button> 
                <Modal title="NEXMOW management system" visible={isModalVisible} 
                  onOk={handleUpdate} onCancel={handleCancel}>
                  <p>Are you sure to update this account?</p>
                </Modal>
            </div>
              
            <div className="accform-wrapper">
              <Form
                  name="normal_login"
                  className="login-form_list"
                  form={form}
                  layout="vertical"
                  onChange={handleChange}
                  initialValues={branch}
                >
                <Form.Item 
                    label="Company" required 
                    className="account_detail_form">
                    <p className="account_company">{branch.company}</p> 
                </Form.Item>
                <Form.Item 
                    label="Email address" required 
                    className="account_detail_form">
                    <p className="account_email">{branch.email}</p> 
                </Form.Item>
                <Form.Item 
                    label="Name" required 
                    className="account_detail_form">
                    <Input placeholder={branch.name} name="name"/>
                </Form.Item>
                <Form.Item 
                    label="Administrator" required 
                    className="account_detail_form ">
                    <input className="robot_select" type="checkbox" value="admin" name="admin" checked={userData.admin} onChange={handleChange}/>
                </Form.Item>
              </Form>
              <Form
                  name="normal_login"
                  //className="login-form_list"
                  form={form}
                  layout="vertical"
                  onChange={handleChange}
                  initialValues={branch}
                >
                <Form.Item
                    label="Phone number (optional)"
                    className="account_detail_form"
                >
                    <Input placeholder={branch.phone} name="phone"/>
                </Form.Item>
                <Form.Item
                    label="Address (optional)"
                    className="account_detail_form"
                >
                    <Input placeholder={branch.address} name="address"/>
                </Form.Item>
                <Form.Item
                    label="Zip code (optional)"
                    className="account_detail_form"
                >
                    <Input placeholder={branch.address_zip} name="address_zip"/>
                </Form.Item>
                <Form.Item
                    label="Job title (optional)"
                    className="account_detail_form"
                >
                    <Input placeholder={branch.job} name="job"/>
                </Form.Item>
              </Form>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default BranchItemDetail;